import { goRequest } from '../utils/httpClientTs';
import {
  Newsfeed,
  NewsFeedDetail,
  NewsFeedCreateRequest,
  NewsFeedUpdateRequest,
} from '../types/newsfeed';
import { GenericResponse } from '../types/generic';

export const getNewsfeeds = async (): Promise<Newsfeed[]> => {
  return goRequest<Newsfeed[]>({
    url: '/newsfeeds',
    method: 'GET',
  });
};

export const getNewsfeedById = async (id: string): Promise<NewsFeedDetail> => {
  return goRequest<NewsFeedDetail>({
    url: `/newsfeeds/${id}`,
    method: 'GET',
  });
};

export const createNewsfeedDetail = async (
  data: NewsFeedCreateRequest
): Promise<NewsFeedCreateRequest> => {
  return goRequest<NewsFeedCreateRequest>({
    url: '/newsfeeds',
    method: 'POST',
    data: data,
  });
};

export const updateNewsfeed = async (params: {
  id: string;
  data: NewsFeedUpdateRequest;
}): Promise<GenericResponse> => {
  return goRequest<GenericResponse>({
    url: `/newsfeeds/${params.id}`,
    method: 'PUT',
    data: params.data,
  });
};

export const deleteNewsfeed = async (id: string): Promise<void> => {
  return goRequest<void>({
    url: `/newsfeeds/${id}`,
    method: 'DELETE',
  });
};
